export default __webpack_public_path__ + "static/media/project1-DJI_0878.a1f7bc70.jpg";